import { z } from 'zod'

import type { AustralianState, OrgSort, OrgStatus } from './queries'

/** The state filter's choices, Victoria first as the evaluation wizard lists them. */
export const STATES = [
  'VIC',
  'NSW',
  'QLD',
  'SA',
  'WA',
  'TAS',
  'ACT',
  'NT',
] as const satisfies readonly AustralianState[]

export type OrgTab = 'all' | OrgStatus

/** The status tabs, in the artboard's order. */
export const TABS: { key: OrgTab; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'active', label: 'Active' },
  { key: 'quiet', label: 'Quiet' },
  { key: 'invited', label: 'Invited' },
  { key: 'suspended', label: 'Suspended' },
]

const SORTS = ['-last_active', 'last_active', 'name', '-name'] as const satisfies readonly OrgSort[]

/** Most recently active first; the orgs never active last. */
export const DEFAULT_SORT: OrgSort = '-last_active'

/**
 * The Organisations list's search: the status tab, the search, the state, the sort and the page,
 * in the address. Anything unreadable is dropped rather than refused, which leaves the default.
 */
export const organisationsSearchSchema = z.object({
  tab: z.enum(['all', 'active', 'quiet', 'invited', 'suspended']).optional().catch(undefined),
  q: z.string().max(100).optional().catch(undefined),
  state: z.enum(STATES).optional().catch(undefined),
  sort: z.enum(SORTS).optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
})

export type OrganisationsSearch = z.output<typeof organisationsSearchSchema>
